import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import {Observable} from "rxjs";
import {EducationMom} from "./education-mom.model";
import {EducationObservation} from "../educationObservation/education-observation.model";

@Injectable({
  providedIn: 'root'
})
export class EducationMomService {
  private collection = this.firestore.collection<EducationMom>('educationMom');

  constructor(private firestore: AngularFirestore) {}

  create(data: EducationMom): Promise<any> {
    const payload: EducationMom = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  getDataById(id: string): Observable<EducationMom | undefined> {
    return this.collection.doc<EducationMom>(id).valueChanges({ idField: 'id' });
  }

  // getAll(): Observable<EducationMom[]> {
  //   return this.collection.valueChanges({ idField: 'id' });
  // }
  getAll(): Observable<EducationObservation[]> {
    return this.firestore.collection<EducationObservation>(
      'educationMom', ref => ref.orderBy('date', 'desc')).valueChanges({ idField: 'id' });
  }
  update(id: string, data: Partial<EducationMom>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}
